import React from 'react';

import Link from '@amzn/meridian/link';
import ProgressTracker, { ProgressTrackerStep } from '@amzn/meridian/progress-tracker';

import { useHistory } from 'react-router-dom';
import { IStepTrackerStep } from 'src/types/IStepTrackerStep';

import './StepTracker.scss';

interface IStepTrackerProps {
    currentStepIndex: number;
    basePath: string;
    steps: IStepTrackerStep[];
    trackLength?: number;

    /**
     * Callback to trigger when a link in the tracker is clicked.
     *
     * Defaults to React's history.push.
     * @param path The path the visit.
     */
    onClick?: (path: string) => void;
}

export const StepTracker = ({ currentStepIndex, basePath, steps, trackLength, onClick }: IStepTrackerProps) => {
    onClick ??= useHistory().push;

    return (
        <ProgressTracker type="theme" compact={true} direction="column" rowLabelAlignment="start">
            {steps.map(({ stepId, stepTitle }, index) => {
                const state = currentStepIndex > index ? 'past' : currentStepIndex === index ? 'present' : 'future';
                return (
                    <ProgressTrackerStep
                        key={stepId}
                        type={state}
                        showLabel={true}
                        trackLength={trackLength ?? steps.length}
                        label={
                            state === 'past' ? (
                                <Link href={`${basePath}${stepId}`} onClick={onClick}>
                                    {stepTitle}
                                </Link>
                            ) : (
                                stepTitle
                            )
                        }
                    />
                );
            })}
        </ProgressTracker>
    );
};
